module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [(_vm.set_view == 'deluxe') ? _c('div', [_vm._m(0)]) : _vm._e()])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "80vh",
      "margin": "1em",
      "padding": "8em 3em",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "125px",
      "padding": "1em",
      "background-color": "#ffffff",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('h3', [_vm._v("Deluxe Shopping")]), _vm._v(" "), _c('p', [_vm._v("Unlimited Collections and Saved Shops")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('h3', [_vm._v("₦5000 "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("/ monthly")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-height": "125px",
      "padding": "1em",
      "background-color": "#ffffff",
      "border-radius": "5px",
      "box-shadow": "0 0 30px 4px rgba(0,0,0,0.03)"
    }
  }, [_c('h3', [_vm._v("Deluxe Business")]), _vm._v(" "), _c('p', [_vm._v("Unlimited Shops and more")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('h3', [_vm._v("₦5000 "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("/ monthly")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d98a3986"}!./src/pages/Updates/template.html
// module id = 588
// module chunks = 0